import { render, staticRenderFns } from "./ClienteProveedorPantalla.vue?vue&type=template&id=6cb43dec&"
import script from "./ClienteProveedorPantalla.vue?vue&type=script&lang=ts&"
export * from "./ClienteProveedorPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6cb43dec', component.options)
    } else {
      api.reload('6cb43dec', component.options)
    }
    module.hot.accept("./ClienteProveedorPantalla.vue?vue&type=template&id=6cb43dec&", function () {
      api.rerender('6cb43dec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ClienteProveedor/ClienteProveedorPantalla.vue"
export default component.exports